import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { useGlobal } from '@/contexts/GlobalContext';
import { getCurrentTabMenu } from '@/utils/getCurrentTabMenu';
import { TabMenu } from '@/types/menu';
import { formatYYYYmmWithHyphen } from '@/utils/date';

export function useCurrentTabMenu() {
  const location = useLocation();
  const navigate = useNavigate();
  const context = useGlobal();
  const [currentMenu, setCurrentMenu] = useState<TabMenu | undefined>();
  const [menuItems, setMenuItems] = useState<{ label: React.ReactNode; onClick: () => void }[]>([]);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // サッカーノートカレンダーのデフォルト日付を設定
  let date: Date;
  if (context.systemDate != null) {
    date = new Date(context.systemDate);
  } else {
    date = new Date();
  }
  const systemDateYearMonth = formatYYYYmmWithHyphen(date);

  const handleMoveTo = (path: string) => {
    navigate(path);
  };

  useEffect(() => {
    const menu = getCurrentTabMenu(location.pathname);
    setCurrentMenu(menu);
    setMenuItems(getMenuItemsForCurrentMenu(menu));
    setActiveIndex(getActiveIndexForCurrentMenu(menu));
  }, [location.pathname]);

  const getActiveIndexForCurrentMenu = (menu: TabMenu | undefined) => {
    switch (menu) {
      case 'HOME':
        return 0;
      case 'NOTE_CALENDAR':
        return 0;
      case 'NOTE':
        return 1;
      case 'GOALS':
        return 0;
      case 'SUPPORTER':
        return 0;
      case 'SUPPORTER_FEED':
        return 1;
      default:
        return 0;
    }
  };

  const getMenuItemsForCurrentMenu = (menu: TabMenu | undefined) => {
    switch (menu) {
      case 'HOME':
        return [
          {
            label: <>HOME</>,
            onClick: () => handleMoveTo(`/home`)
          }
        ];
      case 'NOTE_CALENDAR':
      case 'NOTE':
        return [
          {
            label: <>カレンダー</>,
            onClick: () => handleMoveTo(`/notes/calendar/${systemDateYearMonth}`)
          },
          {
            label: <>サッカーノート</>,
            onClick: () => handleMoveTo(`/notes`)
          }
        ];
      case 'GOALS':
        return [
          {
            label: <>目標・課題</>,
            onClick: () => handleMoveTo(`/goals`)
          }
        ];
      case 'SUPPORTER':
      case 'SUPPORTER_FEED':
        return [
          {
            label: <>サポーター検索</>,
            onClick: () => handleMoveTo(`/supporters`)
          },
          {
            label: <>サポーターフィード</>,
            onClick: () => handleMoveTo(`/supporters/feeds`)
          }
        ];
      default:
        return [];
    }
  };

  return { currentMenu, menuItems, activeIndex };
}
